// extracted by mini-css-extract-plugin
export default {"helloworld":"Home_helloworld__YuMuC","topSeparator":"Home_topSeparator__MQnVb","bookNowA":"Home_bookNowA__a2GTI"};